(function () {
  function decodeHTMLEntities(text) {
    const textarea = document.createElement("textarea");
    textarea.innerHTML = text;
    return textarea.value;
  }

  async function fetchCollectionProducts(
    collectionHandle,
    page = 1,
    sort = ""
  ) {
    const url = new URL(
      `/collections/${collectionHandle}`,
      window.location.origin
    );
    url.searchParams.set("view", "ajax");
    url.searchParams.set("page", page);

    if (sort) {
      url.searchParams.set("sort_by", sort);
    }

    try {
      const response = await fetch(url.toString());
      if (!response.ok) throw new Error("Network response was not ok");
      return await response.text();
    } catch (error) {
      console.error("Error fetching products:", error);
      return null;
    }
  }

  function updateProductGrid(html) {
    const productContainer = document.querySelector(".collection-products");
    if (!productContainer) return;
    productContainer.innerHTML = html;
    initializeLoadMoreButtons();
  }

  function initializeLoadMoreButtons() {
    const loadMoreButton = document.querySelector(".load-more-button");
    if (loadMoreButton) {
      loadMoreButton.addEventListener("click", handleLoadMore);
    }
  }

  async function handleLoadMore(e) {
    const button = e.target;
    const currentPage = parseInt(button.dataset.currentPage);
    const totalPages = parseInt(button.dataset.totalPages);
    const collectionHandle = window.location.pathname.split("/collections/")[1];

    if (currentPage >= totalPages) return;

    button.disabled = true;
    button.classList.add("loading");

    const sortBy =
      document.querySelector('.sort-by__button[aria-pressed="true"]')?.dataset
        .sortBy ||
      document.getElementById("sort_by")?.value ||
      "";

    try {
      const html = await fetchCollectionProducts(
        collectionHandle,
        currentPage + 1,
        sortBy
      );
      if (html) {
        const temp = document.createElement("div");
        temp.innerHTML = html;

        const productCards = temp.querySelectorAll(".collection-product");
        const productList = document.querySelector(
          ".collection-products__list"
        );

        productCards.forEach((card) => {
          productList.appendChild(card);
        });

        button.dataset.currentPage = currentPage + 1;

        if (currentPage + 1 >= totalPages) {
          document.querySelector(".collection__pagination").remove();
        }
      }
    } catch (error) {
      console.error("Error loading more products:", error);
    } finally {
      if (button && button.parentNode) {
        button.disabled = false;
        button.classList.remove("loading");
      }
    }
  }

  function hasChildren(collectionHandle) {
    return Object.values(window.collectionMap || {}).some(
      (collection) => collection.parent === collectionHandle
    );
  }

  function createFilterButton(collection, level = 0) {
    const button = document.createElement("button");
    button.className = "collection-filter-button text-body";
    button.setAttribute("data-collection", collection.handle);
    button.setAttribute("data-level", level);

    const titleText = decodeHTMLEntities(collection.title);
    button.innerHTML = `${titleText} <span class="collection-filter-button__count">(${
      collection.productCount || 0
    })</span>`;

    attachButtonClickHandler(button, level);
    return button;
  }

  function renderSubCollections(parentHandle, level = 1) {
    const rowContainer = document.createElement("div");
    rowContainer.className = `collection-filters__subrow level-${level}`;
    rowContainer.setAttribute("data-parent", parentHandle);

    const subCollections = Object.values(window.collectionMap || {}).filter(
      (collection) => collection.parent === parentHandle
    );

    subCollections.forEach((collection) => {
      const button = createFilterButton(collection, level);
      rowContainer.appendChild(button);
    });

    return rowContainer;
  }

  function updateBreadcrumbs(selectedCollection) {
    const breadcrumbsList = document.querySelector(
      ".collection-breadcrumbs__list"
    );
    if (!selectedCollection || !window.collectionMap || !breadcrumbsList)
      return;

    const breadcrumbPath = [];
    let currentCollection = window.collectionMap[selectedCollection];

    while (currentCollection) {
      breadcrumbPath.unshift(currentCollection);
      currentCollection = currentCollection.parent
        ? window.collectionMap[currentCollection.parent]
        : null;
    }

    const activeButtons = document.querySelectorAll(
      ".collection-filter-button.active"
    );
    const activePath = Array.from(activeButtons).map((button) => {
      const handle = button.getAttribute("data-collection");
      const collection = window.collectionMap[handle];
      return {
        handle: handle,
        title: collection
          ? collection.title
          : button.textContent.trim().split("(")[0].trim(),
      };
    });

    const completePath = [
      ...new Map(
        [...breadcrumbPath, ...activePath].map((item) => [item.handle, item])
      ).values(),
    ];

    const breadcrumbHTML = `
        <li class="collection-breadcrumbs__item">
          <a href="/collections/all">Products</a>
        </li>
        ${completePath
          .map(
            (collection, index) => `
            <li class="collection-breadcrumbs__item">
              ${
                index === completePath.length - 1
                  ? `<span>${collection.title}</span>`
                  : `<a href="/collections/${collection.handle}">${collection.title}</a>`
              }
            </li>
          `
          )
          .join("")}
      `;

    breadcrumbsList.innerHTML = breadcrumbHTML;
  }

  function handleCollectionChange(collectionHandle) {
    const sortBy =
      document.querySelector('.sort-by__button[aria-pressed="true"]')?.dataset
        .sortBy ||
      document.getElementById("sort_by")?.value ||
      "";

    const productGrid = document.querySelector(".collection-products__list");
    if (productGrid) {
      productGrid.classList.add("loading");
    }

    fetchCollectionProducts(collectionHandle, 1, sortBy)
      .then((html) => {
        if (html) {
          updateProductGrid(html);

          const url = new URL(
            window.location.origin + `/collections/${collectionHandle}`
          );
          if (sortBy) {
            url.searchParams.set("sort_by", sortBy);
          }
          window.history.pushState({ path: url.href }, "", url.href);
        }
      })
      .finally(() => {
        const updatedProductGrid = document.querySelector(
          ".collection-products__list"
        );
        if (updatedProductGrid) {
          updatedProductGrid.classList.remove("loading");
        }
      });
  }

  function handleButtonClick(button, level) {
    const subrowContainer = document.querySelector(
      ".collection-filters__subrows"
    );
    const filterButtons = document.querySelectorAll(
      ".collection-filter-button[data-collection]"
    );

    if (!subrowContainer) return;

    const collectionHandle = button.getAttribute("data-collection");

    if (level === 0) {
      subrowContainer.innerHTML = "";
      filterButtons.forEach((b) => b.classList.remove("active"));
    } else {
      const allSubsequentLevels = document.querySelectorAll(
        `.collection-filters__subrow[class*="level-"]:nth-child(n+${level + 1})`
      );
      allSubsequentLevels.forEach((row) => row.remove());

      const sameLevel = button
        .closest(".collection-filters__subrow")
        .querySelectorAll(".collection-filter-button");
      sameLevel.forEach((b) => b.classList.remove("active"));
    }

    button.classList.add("active");

    if (hasChildren(collectionHandle)) {
      const nextRow = renderSubCollections(collectionHandle, level + 1);
      if (level === 0) {
        subrowContainer.appendChild(nextRow);
      } else {
        const currentRow = button.closest(".collection-filters__subrow");
        const nextSibling = currentRow.nextElementSibling;
        if (nextSibling) {
          nextSibling.remove();
        }
        currentRow.after(nextRow);
      }
    }

    updateBreadcrumbs(collectionHandle);
    handleCollectionChange(collectionHandle);
  }

  function attachButtonClickHandler(button, level) {
    button.addEventListener("click", function (e) {
      e.preventDefault();
      handleButtonClick(button, level);
    });
  }

  function initializeSortButtons() {
    const sortByContainer = document.getElementById("sort_by");
    const sortByButtons = document.querySelectorAll(".sort-by__button");
    const sortByLabel = document.querySelector(".sort-by__label");

    if (!sortByContainer || !sortByButtons.length) return;

    sortByContainer.addEventListener("click", function (e) {
      if (e.target.closest(".sort-by__label")) {
        sortByContainer.classList.toggle("open");
      }
    });

    document.addEventListener("click", function (e) {
      if (
        !e.target.closest("#sort_by") &&
        sortByContainer.classList.contains("open")
      ) {
        sortByContainer.classList.remove("open");
      }
    });

    sortByButtons.forEach((button) => {
      button.addEventListener("click", function () {
        const sortBy = this.getAttribute("data-sort-by");
        const buttonText = this.textContent.trim();

        sortByButtons.forEach((btn) =>
          btn.setAttribute("aria-pressed", "false")
        );
        this.setAttribute("aria-pressed", "true");
        if (sortByLabel) {
          sortByLabel.innerHTML = `${buttonText} <span class="sort-by__label-arrow"><svg class="mega-menu__item-featured-product-caret-icon" width="10" height="10" viewBox="0 0 10 10" aria-hidden="true" focusable="false"><path d="M1 4L5 8L9 4" stroke="currentColor" fill="none" stroke-width="1" stroke-linecap="round"/></svg></span>`;
        }

        sortByContainer.classList.remove("open");

        const pathParts = window.location.pathname.split("/");
        const collectionIndex = pathParts.indexOf("collections");
        const collectionHandle =
          collectionIndex !== -1 && pathParts.length > collectionIndex + 1
            ? pathParts[collectionIndex + 1]
            : "";

        if (!collectionHandle) return;

        const productList = document.querySelector(
          ".collection-products__list"
        );
        if (productList) {
          productList.classList.add("loading");
        }

        fetchCollectionProducts(collectionHandle, 1, sortBy)
          .then((html) => {
            if (html) {
              updateProductGrid(html);

              const url = new URL(window.location.href);
              url.searchParams.set("sort_by", sortBy);
              window.history.pushState({ path: url.href }, "", url.href);
            }
          })
          .finally(() => {
            const productList = document.querySelector(
              ".collection-products__list"
            );
            if (productList) {
              productList.classList.remove("loading");
            }
          });
      });
    });
  }

  function init() {
    const filterButtons = document.querySelectorAll(
      ".collection-filter-button[data-collection]"
    );
    filterButtons.forEach((button) => {
      attachButtonClickHandler(button, 0);
    });

    initializeSortButtons();

    initializeLoadMoreButtons();

    window.handleCollectionChange = handleCollectionChange;
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
